import { cn } from '@/lib/utils'
import type { ButtonHTMLAttributes } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  size?: 'sm' | 'md' | 'lg'
}

export function Button({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-[8px] font-semibold transition-colors duration-150',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(64,219,241,0.45)]',
        'disabled:opacity-50 disabled:pointer-events-none',
        'font-[family-name:var(--font-sans)] tracking-[-0.02em]',
        size === 'sm' && 'min-h-9 px-3.5 text-xs',
        size === 'md' && 'min-h-10 px-4 text-sm',
        size === 'lg' && 'h-11 px-5 text-sm',
        variant === 'primary' &&
          'bg-[#40dbf1] text-[#061014] hover:bg-[#75e8f8]',
        variant === 'secondary' &&
          'bg-transparent text-[#40dbf1] border border-[rgba(64,219,241,0.45)] hover:bg-[rgba(64,219,241,0.08)] hover:border-[#40dbf1]',
        variant === 'ghost' &&
          'text-[#9aabbb] hover:text-[#f0f4f8] hover:bg-[rgba(255,255,255,0.04)]',
        variant === 'danger' &&
          'bg-[#a83748] text-white hover:bg-[#bd4556]',
        className,
      )}
      {...props}
    />
  )
}
